import { render, staticRenderFns } from "./JournalCategory.vue?vue&type=template&id=18409cb4&scoped=true&"
import script from "./JournalCategory.vue?vue&type=script&lang=js&"
export * from "./JournalCategory.vue?vue&type=script&lang=js&"
import style0 from "./JournalCategory.vue?vue&type=style&index=0&id=18409cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18409cb4",
  null
  
)

export default component.exports